import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from "vuetify/es5/locale/es"
import 'vuetify/src/stylus/app.styl'
import '../theme/default.styl'
Vue.use(Vuetify, {
  lang: {
    locales: { es },
    current: 'es'
  },
  theme: {
    primary: '#4592af',
    secondary: '#33313b',
    accent: '#e3c4a8',
    error: '#ff6768',
    info: '#28c3d4',
    success: '#00bd56',
    warning: '#f8b739'
  },
  customProperties: true,
  iconfont: 'md',
})
